import { useParams } from "react-router-dom";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import React, { useEffect } from "react";
import {
  getRequest,
  setLoading,
  clear,
} from "../../infrastructure/slices/requestMutateSlice";
import RequestMutateForm from "../features/requestMutateForm";
import LicensePlate from "license-plate";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { useAuthorization } from "../../../../hooks/useAuthorization";
import { util } from "zod";
import isInteger = util.isInteger;

export const RequestMutatePage = () => {
  const { id } = useParams();
  const { hasRole } = useAuthorization();

  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const { loading, request } = useAppSelector((state) => state.requestMutate);

  useEffect(() => {
    if (!id) {
      dispatch(clear());
      return;
    }

    const parsedId = Number(id);
    if (isInteger(parsedId)) {
      void dispatch(getRequest(id));
    } else {
      dispatch(setLoading(false));
    }

    return () => {
      dispatch(clear());
    };
  }, [id]);

  const title = t("Request");

  const licensePlate = request?.source?.car?.licence
    ? new LicensePlate(request.source?.car.licence).pretty()
    : "";

  if (!id) {
    return <></>;
  }
  if (!request?.id && loading) return <></>;

  if (
    !request?.id ||
    hasRole("dbh-employee") ||
    hasRole("dbh-driver") ||
    hasRole("dbh-order-picker")
  ) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} loading={loading} />
          <Breadcrumb>
            <BreadCrumbItem to="/tire-sets">{t(`Tire sets`)}</BreadCrumbItem>
            {(request?.source?.car?.id ?? false) && (
              <BreadCrumbItem to={`/car/${request?.source?.car?.id}/edit`}>
                {licensePlate ?? ""} {request?.source?.car?.label}
              </BreadCrumbItem>
            )}
            {(request?.source?.car?.id ?? false) && (
              <BreadCrumbItem to={`/request/${request?.id}`}>
                {t(`Request`)}
              </BreadCrumbItem>
            )}
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      {!loading && <RequestMutateForm key={id} submitButtonLabel={t("Save")} />}
    </Layout>
  );
};
